import React, { useState } from "react";
import { Family } from "../../pageInside/Rolle";
import notData from '../../Layout/imgs/nodata0.png';
import { elakayAutoText } from "../../pageInside/dataElakay";



const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  green: "#10b981", greenLt: "#f0fdf4",
  red: "#ef4444", redLt: "#fff5f5",
  yellow: "#f59e0b", yellowLt: "#fef3c7",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,sans-serif",
  radius: 8,
};

const Toggle = ({ checked, onChange, label }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <button type="button" onClick={onChange}
      style={{
        position: "relative", width: 42, height: 24, padding: 0, border: "none",
        background: checked ? D.blue : "#cbd5e1", borderRadius: 12,
        cursor: "pointer", transition: "background .2s", flexShrink: 0,
      }}>
      <span style={{
        position: "absolute", top: 3, left: checked ? 21 : 3,
        width: 18, height: 18, background: "#fff", borderRadius: "50%",
        transition: "left .2s", display: "block",
      }} />
    </button>
    {label && <span style={{ fontSize: 12, color: D.txt3, fontWeight: 600 }}>{label}</span>}
  </div>
);

var fileAdding = { title: '', error: '', message: '' };

const FormPageErrorElakay = (props) => {
  const {
    infoSource,
    editAdd, setEditAdd, editAddByJson = false,
    menu, nameObj, objet, setObejet,
    infoElakay, edit_add, token,
    Alllanguage, AlllanguageSelect,
    getDataEmail, getDataMessErr,
    languageUsertra, languageTradictor,
    updateLanguageElakay0, buttonAddLanguage
  } = props;

  const __elakayText = (key, fallback = '') => {
    const val = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.formPageErrorElakay?.[key];
    return typeof val === 'string' ? val : fallback;
  };

  const defExempleJSOM = '<!-- enter your combined JSON here... -->';
  const allTitle = ['users', 'categories', 'elakay language', 'filters', 'help contact', 'images', 'messages', 'orders', 'products', 'pub elakay'];

  const [newobjet, setNewObejet] = useState();
  const [editJson, setEditJson] = useState(true);
  const [getNotData, setNotData] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [jsonInput, setJsonInput] = useState(defExempleJSOM);
  const [getTilte, setTilte] = useState();

  const checkIfFunction = (f) => typeof f === 'object' ? true : false;

  const checkProdKeyExit = (ad, ld) => {
    let ent = Object.keys(ad ? ad : {});
    let lent = Object.keys(ld ? ld : {});
    let apiEvery = ent.every((key) => ad[key] != undefined);
    let lengthObj = ent?.length === lent?.length;
    return apiEvery && lengthObj ? true : false;
  };

  const [error, setError] = useState('');

  const checkObjEmpty = (a) => JSON.stringify(a) === '{}';

  const checkProductTrue = (ad) => {
    let array = Object.values(ad)?.map(e => e !== '');
    return array.every(a => a === true) && true;
  };

  const buttonAdd = () => {
    let data = JSON.parse(jsonInput);
    updateLanguageElakay0(languageTradictor._id, token, { [nameObj]: data }, Family()).then(data => {
      if (data.error) { setError(data.error); }
      else { AlllanguageSelect(); languageUsertra(); }
    });
  };

  let clickEditAdd = () => {
    setEditAdd(editAdd ? false : true);
    if (!edit_add && !checkProdKeyExit(languageTradictor[nameObj], infoElakay)) {
      setObejet(editAdd ? languageTradictor[nameObj] : menu);
    } else {
      setError(editAdd ? elakayAutoText("h_932f30ae638ce2", "they is no data to edit") : "");
      setObejet(infoElakay);
    }
  };

  const selTraErrMess = (data, value) => {
    languageTradictor[nameObj].filter(obj => {
      obj.title == value ? setNewObejet(obj) : setNewObejet(data);
    });
  };

  const traErrMessBool = (array = [], title) =>
    array.filter(obj => obj.title == title)[0] ? true : false;

  const submitALLData = (obj, value, mss = null) => {
    setNewObejet(obj);
    Family() && setJsonInput(JSON.stringify(obj, null, 3));
    setErrorMessage(mss);
    setTilte(value);
  };

  const transformJson = (jsonObj) => {
    const newObj = { ...jsonObj };
    delete newObj._id;
    const clearValues = (obj) => {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) { obj[key] = ""; }
      }
    };
    clearValues(newObj.error);
    clearValues(newObj.message);
    return newObj;
  };

  const handleTilteData = () => event => {
    const value = event.target.value;
    setNotData(false);
    if (Family()) {
      let data = { ...infoElakay[0], title: value };
      traErrMessBool(languageTradictor[nameObj], value)
        ? languageTradictor[nameObj].filter(obj => obj.title == value && submitALLData(obj, value))
        : submitALLData(data, value);
    } else {
      if (traErrMessBool(languageTradictor[nameObj], value)) {
        languageTradictor[nameObj].filter(obj => obj.title == value && submitALLData(obj, value));
      } else {
        if (traErrMessBool(getDataMessErr, value)) {
          getDataMessErr.filter(obj => obj.title == value && submitALLData(transformJson(obj), value));
        } else {
          setNotData(true);
          submitALLData({}, value);
        }
      }
    }
  };

  const handleChange = name => event => {
    const value = event.target.value;
    let pname = name[0];
    let sname = name[1];
    if (name?.length == 2) {
      let newData = { ...newobjet, [pname]: { ...newobjet[pname], [sname]: value } };
      setNewObejet(newData);
      setJsonInput(JSON.stringify(newData, null, 3));
    } else {
      let newData = { ...newobjet, [pname]: value };
      setNewObejet(newData);
      setJsonInput(JSON.stringify(newData, null, 3));
    }
  };

  const checkUndefName = (a, b) => {
    let aa = a && Object.keys(a);
    return a && aa.includes(b);
  };

  const inputOK = (a, b, c) => {
    if (c == undefined) return { v: b, s: 'neutral' };
    else if (c == {}) return { v: "", s: 'invalid' };
    else if (checkUndefName(c, a)) return { v: c[a], s: 'valid' };
    else return { v: "", s: 'invalid' };
  };

  const checkValue = (val) =>
    languageTradictor[nameObj] != undefined ? languageTradictor[nameObj] : val;

  const btnSubmitJson = (obj) => {
    try {
      setNewObejet(JSON.parse(obj));
      setEditJson(true);
      setErrorMessage(null);
    } catch (error) {
      setErrorMessage(elakayAutoText("h_3e885b57a51a6b", "Erreur de syntaxe JSON : {value0}", { value0: error.message }));
    }
  };

  const handlJsonInput = (obj) => {
    try {
      setJsonInput(obj);
      setErrorMessage(null);
    } catch (error) {
      setErrorMessage(elakayAutoText("h_3e885b57a51a6b", "Erreur de syntaxe JSON : {value0}", { value0: error.message }));
    }
  };

  // ── shared style helpers ──────────────────────────────────────────────────
  const inpSt = (s) => ({
    width: "100%", padding: "7px 10px", boxSizing: "border-box",
    border: `1px solid ${s === 'invalid' ? D.red : D.border}`,
    borderRadius: D.radius, fontSize: 13, color: D.txt1, fontFamily: D.font,
    background: s === 'invalid' ? D.redLt : "#fff", outline: "none",
  });

  const lblSt = {
    display: "block", fontSize: 11, fontWeight: 700, color: D.txt3,
    textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 4,
  };

  // ── sub-renders ───────────────────────────────────────────────────────────
  const selectObArData = () => (
    <div style={{ marginBottom: 16 }}>
      <label style={lblSt}>{__elakayText("t003", "data title for edit")}</label>
      <select onChange={handleTilteData()}
        style={{ width: "100%", padding: "7px 10px", boxSizing: "border-box", border: `1px solid ${D.border}`, borderRadius: D.radius, fontSize: 13, color: D.txt1, fontFamily: D.font, background: "#fff", outline: "none", cursor: "pointer" }}>
        <option value={0}>{__elakayText("t004", "select data title")}</option>
        {allTitle?.map((ob, j) =>
          <option key={j} value={ob}>{ob}</option>
        )}
      </select>
    </div>
  );

  const formInput1 = (a, b, i, akey, c) => {
    let inpClass = c == undefined ? "neutral" : checkUndefName(c, a) ? "valid" : 'invalid';
    return (
      <div key={i} style={{ marginBottom: 10 }}>
        <label style={lblSt}>{a}</label>
        {b?.length > 90
          ? <textarea onChange={handleChange([akey, a])} value={newobjet[akey][a]} rows={4}
              placeholder={getDataMessErr ? getDataMessErr[akey] : ''}
              style={{ ...inpSt(inpClass), resize: "vertical", fontFamily: "monospace" }} />
          : <input onChange={handleChange([akey, a])} type="text" value={newobjet[akey][a]}
              placeholder={getDataMessErr ? getDataMessErr[akey] : ''}
              style={inpSt(inpClass)} />
        }
      </div>
    );
  };

  const formInput0 = (a, b, i, c) => {
    let oe1 = Object.entries(b);
    let inpClass = c == undefined ? "neutral" : checkUndefName(c, a) ? "valid" : 'invalid';
    return a != "title" && a != "_id" && (
      <div key={i} style={{ marginBottom: 14 }}>
        <label style={checkIfFunction(b)
          ? { fontSize: 12, fontWeight: 700, color: D.txt2 }
          : lblSt}>
          {checkIfFunction(b) ? a.toUpperCase() : a}
        </label>
        {checkIfFunction(b)
          ? (
            <div style={{ background: D.bg, borderRadius: D.radius, border: `1px solid ${D.border}`, padding: "12px 14px" }}>
              {oe1?.map(([key, val], i) => formInput1(key, val, i, a))}
            </div>
          )
          : (
            <div style={{ marginTop: 4 }}>
              {b?.length > 90
                ? <textarea onChange={handleChange([a])} value={newobjet[a]} rows={4}
                    placeholder={b} style={{ ...inpSt(inpClass), resize: "vertical", fontFamily: "monospace" }} />
                : <input onChange={handleChange([a])} type="text" value={newobjet[a]}
                    placeholder={b} style={inpSt(inpClass)} />
              }
            </div>
          )
        }
      </div>
    );
  };

  const inputJson = () => {
    let oe = newobjet && Object.entries(newobjet);
    return (
      <div style={{ marginBottom: 16 }}>
        {/* JSON editor header */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: 10, marginBottom: 12, borderBottom: `1px solid ${D.border}` }}>
          <h3 style={{ fontSize: 13, fontWeight: 700, color: D.txt2, margin: 0 }}>
            {__elakayText("t005", "JSON Input")}
          </h3>
          <Toggle
            checked={editJson}
            onChange={() => { setEditJson(editJson ? false : true); setErrorMessage(null); }}
            label={__elakayText("t002", "edit json input")} />
        </div>

        <textarea
          value={jsonInput}
          onChange={(e) => !editJson && handlJsonInput(e.target.value)}
          placeholder={defExempleJSOM}
          style={{
            width: "100%", minHeight: 400, padding: "12px 14px", boxSizing: "border-box",
            border: `1px solid ${D.border}`, borderRadius: D.radius,
            fontFamily: "monospace", fontSize: 12, color: D.txt1,
            background: D.bg, resize: "vertical", outline: "none",
          }}
        />

        {!editJson && (
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
            <button type="button" onClick={() => btnSubmitJson(jsonInput)}
              style={{ padding: "8px 20px", borderRadius: D.radius, border: "none", background: D.blue, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}>
              {__elakayText("t007", "submit")}
            </button>
          </div>
        )}
      </div>
    );
  };

  const formInput = () => {
    let oe = newobjet && Object.entries(newobjet);
    return (
      <div>
        {getTilte && (
          <div style={{ paddingBottom: 10, marginBottom: 14, borderBottom: `1px solid ${D.border}` }}>
            <h3 style={{ fontSize: 13, fontWeight: 700, color: D.txt2, margin: 0 }}>
              {__elakayText("t006", "Message & Error of")} {getTilte}
            </h3>
          </div>
        )}
        {newobjet && oe?.map(([key, val], i) => formInput0(key, val, i))}
        {getTilte && editJson && (
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
            <button type="button" onClick={() => buttonAdd()}
              style={{ padding: "8px 20px", borderRadius: D.radius, border: "none", background: D.green, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: D.font }}>
              {__elakayText("t008", "save")}
            </button>
          </div>
        )}
      </div>
    );
  };

  const loadErrorMessage = () => (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: `1px solid #fca5a5`, marginTop: 10 }}>
      <span style={{ fontSize: 16, flexShrink: 0 }}>⚠</span>
      <span style={{ fontSize: 12, color: "#991b1b" }}>{errorMessage}</span>
    </div>
  );

  const notDataImgs = () => (
    <div style={{ display: "flex", justifyContent: "center", padding: "24px 0" }}>
      <img src={notData} alt={__elakayText("t009", "No data")}
        style={{ maxHeight: 200, maxWidth: "100%", opacity: 0.7 }} />
    </div>
  );

  return (
    <div>
      {selectObArData()}
      {error && (
        <div style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: `1px solid #fca5a5`, marginBottom: 10 }}>
          <span style={{ fontSize: 16, flexShrink: 0 }}>⚠</span>
          <span style={{ fontSize: 12, color: "#991b1b" }}>{error}</span>
        </div>
      )}
      {Family() && inputJson()}
      {getNotData
        ? notDataImgs()
        : !errorMessage
          ? editJson && formInput()
          : loadErrorMessage()
      }
    </div>
  );
};

export default FormPageErrorElakay;
